import { FC } from "react";
import { Navigate, useParams } from "react-router-dom";

const ObepLegacyDetailRedirect: FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/academics/obep/${id}`} replace />;
};

export default ObepLegacyDetailRedirect;
